import React from 'react';
import { Link } from 'react-router-dom';
import { Coffee, IceCreamConeIcon, TrendingUp, Users, MapPin, Clock, Utensils, Heart, Gift, CheckCircle, Target, Zap, CakeIcon } from 'lucide-react';
export default function UseCases() {
  return <div className="min-h-screen bg-[#f5f5f5] font-sans" data-id="element-213">
      {/* Navigation */}
      <nav className="relative z-20 flex justify-between items-center p-6 md:px-12" data-id="element-214">
        <Link to="/" className="text-2xl font-black tracking-tight text-black" data-id="element-215">
          Waitlist.
        </Link>
        <div className="flex items-center gap-6" data-id="element-216">
          <div className="hidden md:flex gap-6 text-gray-600 font-medium" data-id="element-217">
            <Link to="/" className="hover:text-black transition-colors" data-id="element-218">
              Home
            </Link>
            <Link to="/demo" className="hover:text-black transition-colors" data-id="element-219">
              Demo
            </Link>
          </div>
          <div className="flex items-center gap-2" data-id="element-220">
            <span className="text-black font-medium" data-id="element-221">Use Cases</span>
          </div>
        </div>
      </nav>

      <div className="container mx-auto px-6 py-12" data-id="element-222">
        <div className="max-w-6xl mx-auto" data-id="element-223">
          <h1 className="text-4xl md:text-6xl font-black text-black mb-6 text-center tracking-tight" data-id="element-224">
            Scenarios
          </h1>

          <div className="text-center text-gray-600 mb-16" data-id="element-225">
            <p className="text-lg md:text-xl max-w-3xl mx-auto" data-id="element-226">
              Discover how businesses like yours in Hyderabad are transforming
              their operations with Kraya
            </p>
          </div>

          {/* How It Works Section */}
          <div className="mb-20" data-id="element-227">
            <div className="bg-white rounded-[2rem] p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-228">
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-10 text-center" data-id="element-229">
                How It Works
              </h2>

              <div className="grid md:grid-cols-3 gap-8" data-id="element-230">
                <div className="text-center" data-id="element-231">
                  <div className="bg-blue-50 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center" data-id="element-232">
                    <CheckCircle className="h-8 w-8 text-blue-600" data-id="element-233" />
                  </div>
                  <h3 className="text-xl font-bold text-black mb-3" data-id="element-234">
                    1. Sign Up — Free
                  </h3>
                  <div className="space-y-2 text-gray-600" data-id="element-235">
                    <p data-id="element-236">List your store on Kraya.</p>
                    <p data-id="element-237">Local customers can now find you easily.</p>
                  </div>
                </div>

                <div className="text-center" data-id="element-238">
                  <div className="bg-green-50 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center" data-id="element-239">
                    <Zap className="h-8 w-8 text-green-600" data-id="element-240" />
                  </div>
                  <h3 className="text-xl font-bold text-black mb-3" data-id="element-241">
                    2. Turn On Auto-Rewards
                  </h3>
                  <div className="space-y-2 text-gray-600" data-id="element-242">
                    <p data-id="element-243">Set simple perks like:</p>
                    <p className="italic font-medium text-green-700" data-id="element-244">
                      "Visit 3 times, get 1 free."
                    </p>

                    <p data-id="element-245">
                      They just visit — Kraya tracks everything in the
                      background.
                    </p>
                  </div>
                </div>

                <div className="text-center" data-id="element-246">
                  <div className="bg-purple-50 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center" data-id="element-247">
                    <Target className="h-8 w-8 text-purple-600" data-id="element-248" />
                  </div>
                  <h3 className="text-xl font-bold text-black mb-3" data-id="element-249">
                    3. Get More Foot Traffic
                  </h3>
                  <div className="space-y-2 text-gray-600" data-id="element-250">
                    <p data-id="element-251">Reach Gen Z nearby.</p>
                    <p data-id="element-252">Show up in their feed.</p>
                    <p data-id="element-253">Earn repeat visits — effortlessly.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Use Case 1: Independent Café */}
          <div className="mb-24" data-id="element-254">
            <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-255">
              <div className="order-2 lg:order-1" data-id="element-256">
                <div className="flex items-center gap-4 mb-8" data-id="element-257">
                  <div className="bg-orange-100 p-4 rounded-2xl" data-id="element-258">
                    <Coffee className="h-8 w-8 text-orange-600" data-id="element-259" />
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-black" data-id="element-260">
                    Independent Café
                  </h2>
                </div>

                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 mb-6" data-id="element-261">
                  <h3 className="text-xl font-bold mb-2" data-id="element-262">Scenario</h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-263">
                    A popular café in Jubilee Hills, Hyderabad wants to increase
                    repeat visits from nearby college students and young
                    professionals without investing in clunky loyalty apps or
                    paper punch cards. They want to stand out in a competitive
                    café scene and keep regulars coming back — without heavy
                    discounting.
                  </p>
                </div>

                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 mb-6" data-id="element-264">
                  <h3 className="text-xl font-bold mb-6" data-id="element-265">
                    How Kraya Could Help
                  </h3>
                  <div className="space-y-6" data-id="element-266">
                    <div className="flex items-start gap-4" data-id="element-267">
                      <TrendingUp className="h-6 w-6 text-green-600 mt-1 flex-shrink-0" data-id="element-268" />
                      <div data-id="element-269">
                        <h4 className="font-bold text-black mb-1" data-id="element-270">
                          Effortless Loyalty Rewards
                        </h4>
                        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-271">
                          Automatic return-visit perks (e.g., "Free filter
                          coffee on your 4th visit") applied seamlessly — no app
                          check-ins, no QR codes, no training staff.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4" data-id="element-272">
                      <MapPin className="h-6 w-6 text-purple-600 mt-1 flex-shrink-0" data-id="element-273" />
                      <div data-id="element-274">
                        <h4 className="font-bold text-black mb-1" data-id="element-275">
                          Real-Time Discovery
                        </h4>
                        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-276">
                          Local feed helps the café get discovered by people
                          nearby searching for "filter coffee," "chai spots," or
                          "cozy cafés in Jubilee Hills."
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4" data-id="element-277">
                      <Users className="h-6 w-6 text-red-600 mt-1 flex-shrink-0" data-id="element-278" />
                      <div data-id="element-279">
                        <h4 className="font-bold text-black mb-1" data-id="element-280">
                          Social Word-of-Mouth
                        </h4>
                        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-281">
                          Kraya's social layer makes it easy for loyal fans to
                          recommend their favourite spots and bring friends
                          along — turning one visit into many.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-green-50 rounded-2xl border border-green-100 p-6" data-id="element-282">
                  <h3 className="text-xl font-bold text-green-800 mb-4" data-id="element-283">
                    Expected Outcomes
                  </h3>
                  <ul className="space-y-3 text-green-700 font-medium" data-id="element-284">
                    <li className="flex gap-2" data-id="element-285">
                      <span data-id="element-286">•</span> More repeat visits with no extra tools or
                      staff effort
                    </li>
                    <li className="flex gap-2" data-id="element-287">
                      <span data-id="element-288">•</span> Organic promotion through friend
                      recommendations
                    </li>
                    <li className="flex gap-2" data-id="element-289">
                      <span data-id="element-290">•</span> Visibility among nearby Gen Z crowd looking
                      for their "next favourite café"
                    </li>
                    <li className="flex gap-2" data-id="element-291">
                      <span data-id="element-292">•</span> Stronger brand loyalty in a competitive
                      Jubilee Hills café scene
                    </li>
                  </ul>
                </div>
              </div>

              <div className="order-1 lg:order-2" data-id="element-293">
                <div className="relative h-96 lg:h-[700px] rounded-[2rem] overflow-hidden shadow-xl" data-id="element-294">
                  <img src="https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=800&h=1000&fit=crop&crop=center" alt="Cozy independent café interior" className="w-full h-full object-cover" data-id="element-295" />
                </div>
              </div>
            </div>
          </div>

          {/* Use Case 2: Local Restaurant */}
          <div className="mb-24" data-id="element-296">
            <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-297">
              <div className="relative h-96 lg:h-[700px] rounded-[2rem] overflow-hidden shadow-xl" data-id="element-298">
                <img src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&h=1000&fit=crop&crop=center" alt="Busy restaurant interior" className="w-full h-full object-cover" data-id="element-299" />
              </div>

              <div data-id="element-300">
                <div className="flex items-center gap-4 mb-8" data-id="element-301">
                  <div className="bg-red-100 p-4 rounded-2xl" data-id="element-302">
                    <Utensils className="h-8 w-8 text-red-600" data-id="element-303" />
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-black" data-id="element-304">
                    Local Restaurant
                  </h2>
                </div>

                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 mb-6" data-id="element-305">
                  <h3 className="text-xl font-bold mb-2" data-id="element-306">Scenario</h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-307">
                    A popular biryani and dine-in restaurant in Banjara Hills
                    wants to stay top-of-mind for local diners and encourage
                    repeat visits without relying on Swiggy or Zomato, which
                    take heavy commissions. They want to build direct
                    relationships with their regulars while staying discoverable
                    to new foot traffic in the area.
                  </p>
                </div>

                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 mb-6" data-id="element-308">
                  <h3 className="text-xl font-bold mb-6" data-id="element-309">
                    How Kraya Could Help
                  </h3>
                  <div className="space-y-6" data-id="element-310">
                    <div className="flex items-start gap-4" data-id="element-311">
                      <Heart className="h-6 w-6 text-red-600 mt-1 flex-shrink-0" data-id="element-312" />
                      <div data-id="element-313">
                        <h4 className="font-bold text-black mb-1" data-id="element-314">
                          Smart Loyalty Without Hassle
                        </h4>
                        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-315">
                          Automatic loyalty tracking like "10% off every 4th
                          visit" or "free dessert on your birthday." No coupons,
                          no codes — just effortless perks tied to each visit.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4" data-id="element-316">
                      <MapPin className="h-6 w-6 text-purple-600 mt-1 flex-shrink-0" data-id="element-317" />
                      <div data-id="element-318">
                        <h4 className="font-bold text-black mb-1" data-id="element-319">
                          Menu Discovery + Local Search
                        </h4>
                        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-320">
                          Diners browsing for "biryani near me," "family dinner
                          in Banjara Hills," or "vegetarian thali" can discover
                          the restaurant's menu instantly, with filters like
                          cuisine, mood, or price range.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4" data-id="element-321">
                      <Gift className="h-6 w-6 text-green-600 mt-1 flex-shrink-0" data-id="element-322" />
                      <div data-id="element-323">
                        <h4 className="font-bold text-black mb-1" data-id="element-324">
                          Group Gifting & Social Meals
                        </h4>
                        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-325">
                          Friends dining together can use social gifting
                          features to split rewards or send meal credits. For
                          example, gifting a "dessert on me" token to a friend
                          who hasn't visited yet.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4" data-id="element-326">
                      <Clock className="h-6 w-6 text-blue-600 mt-1 flex-shrink-0" data-id="element-327" />
                      <div data-id="element-328">
                        <h4 className="font-bold text-black mb-1" data-id="element-329">
                          Last-Minute Offers
                        </h4>
                        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-330">
                          On slow nights, push flash offers (e.g., "Free lassi
                          with any biryani before 8 PM") to users within 2 km —
                          drawing in spontaneous traffic.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-red-50 rounded-2xl border border-red-100 p-6" data-id="element-331">
                  <h3 className="text-xl font-bold text-red-800 mb-4" data-id="element-332">
                    Expected Outcomes
                  </h3>
                  <ul className="space-y-3 text-red-700 font-medium" data-id="element-333">
                    <li className="flex gap-2" data-id="element-334">
                      <span data-id="element-335">•</span> Higher frequency of visits from locals
                    </li>
                    <li className="flex gap-2" data-id="element-336">
                      <span data-id="element-337">•</span> Lower dependence on Swiggy & Zomato
                      commissions
                    </li>
                    <li className="flex gap-2" data-id="element-338">
                      <span data-id="element-339">•</span> Boost in off-peak or early dinner traffic
                    </li>
                    <li className="flex gap-2" data-id="element-340">
                      <span data-id="element-341">•</span> A new way for fans to share and celebrate
                      meals socially
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Use Case 3: Dessert Spot */}
          <div className="mb-24" data-id="element-342">
            <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-343">
              <div className="order-2 lg:order-1" data-id="element-344">
                <div className="flex items-center gap-4 mb-8" data-id="element-345">
                  <div className="bg-pink-100 p-4 rounded-2xl" data-id="element-346">
                    <CakeIcon className="h-8 w-8 text-pink-600" data-id="element-347" />
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-black" data-id="element-348">
                    Dessert Spot
                  </h2>
                </div>

                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 mb-6" data-id="element-349">
                  <h3 className="text-xl font-bold mb-2" data-id="element-350">Scenario</h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-351">
                    A trendy dessert spot in Financial District, Hyderabad wants
                    to attract more young professionals and IT crowd after work
                    hours. They've tried Instagram promotions, but converting
                    followers into regular walk-ins has been tough. They need a
                    way to drive real foot traffic — not just likes.
                  </p>
                </div>

                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 mb-6" data-id="element-352">
                  <h3 className="text-xl font-bold mb-6" data-id="element-353">
                    How Kraya Could Help
                  </h3>
                  <div className="space-y-6" data-id="element-354">
                    <div className="flex items-start gap-4" data-id="element-355">
                      <MapPin className="h-6 w-6 text-purple-600 mt-1 flex-shrink-0" data-id="element-356" />
                      <div data-id="element-357">
                        <h4 className="font-bold text-black mb-1" data-id="element-358">
                          Discoverability
                        </h4>
                        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-359">
                          Get listed in "Desserts Near Me" and "Late Night
                          Treats" categories, appearing when users in Financial
                          District search for waffles, gelato, or cheesecake
                          spots.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4" data-id="element-360">
                      <TrendingUp className="h-6 w-6 text-green-600 mt-1 flex-shrink-0" data-id="element-361" />
                      <div data-id="element-362">
                        <h4 className="font-bold text-black mb-1" data-id="element-363">
                          Dynamic Offers
                        </h4>
                        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-364">
                          Set up custom in-app rewards like "Buy 2 desserts, get
                          1 free after 7 PM" based on real customer patterns and
                          peak hours.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4" data-id="element-365">
                      <Gift className="h-6 w-6 text-pink-600 mt-1 flex-shrink-0" data-id="element-366" />
                      <div data-id="element-367">
                        <h4 className="font-bold text-black mb-1" data-id="element-368">
                          Social Gifting
                        </h4>
                        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-369">
                          Let customers gift dessert vouchers to friends —
                          "Treat yourself to a brownie, on me!" drives new
                          visitors through personal recommendations.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4" data-id="element-370">
                      <Users className="h-6 w-6 text-red-600 mt-1 flex-shrink-0" data-id="element-371" />
                      <div data-id="element-372">
                        <h4 className="font-bold text-black mb-1" data-id="element-373">
                          Insights Dashboard
                        </h4>
                        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-374">
                          Learn which desserts are trending, what time the IT
                          crowd visits, and which promos convert best — all
                          without guesswork.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-pink-50 rounded-2xl border border-pink-100 p-6" data-id="element-375">
                  <h3 className="text-xl font-bold text-pink-800 mb-4" data-id="element-376">
                    Expected Outcomes
                  </h3>
                  <ul className="space-y-3 text-pink-700 font-medium" data-id="element-377">
                    <li className="flex gap-2" data-id="element-378">
                      <span data-id="element-379">•</span> More after-work foot traffic from Financial
                      District crowd
                    </li>
                    <li className="flex gap-2" data-id="element-380">
                      <span data-id="element-381">•</span> Turn Instagram followers into actual
                      walk-in customers
                    </li>
                    <li className="flex gap-2" data-id="element-382">
                      <span data-id="element-383">•</span> Viral growth through social gifting and
                      friend referrals
                    </li>
                    <li className="flex gap-2" data-id="element-384">
                      <span data-id="element-385">•</span> Data-driven decisions on menu and
                      promotions
                    </li>
                  </ul>
                </div>
              </div>

              <div className="order-1 lg:order-2" data-id="element-386">
                <div className="relative h-96 lg:h-[700px] rounded-[2rem] overflow-hidden shadow-xl" data-id="element-387">
                  <img src="https://images.unsplash.com/photo-1551024601-bec78aea704b?w=800&h=1000&fit=crop&crop=center" alt="Colorful dessert display" className="w-full h-full object-cover" data-id="element-388" />
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="text-center bg-black rounded-[2rem] p-12 md:p-16 text-white shadow-2xl" data-id="element-389">
            <h3 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-390">
              Ready to Transform Your Business?
            </h3>
            <p className="text-lg text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-391">
              These use cases give business owners in Hyderabad a clear glimpse
              into how Kraya can make loyalty, discovery, and rewards
              frictionless — without needing new hardware, manual tracking, or
              complex integrations.
            </p>
            <a href="mailto:hello@kraya.shop" className="bg-white text-black px-10 py-4 rounded-full hover:bg-gray-200 transition-colors font-bold text-lg inline-block shadow-lg" data-id="element-392">
              Talk to our team
            </a>
            <p className="text-gray-400 text-sm mt-4" data-id="element-393">
              We respond within 24 hours
            </p>
          </div>
        </div>
      </div>
    </div>;
}